module.exports = __webpack_public_path__ + "img/hippocast_logo_bluebg.d9d442ce.png";